import { render, staticRenderFns } from "./Ending.vue?vue&type=template&id=65385448&scoped=true&lang=pug"
var script = {}
import style0 from "./Ending.vue?vue&type=style&index=0&id=65385448&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_css-loader@6.11.0_webpack@5.96.1__lodash@4.17.21__lkjqg4lemhx3tcnq4xpodjyioi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65385448",
  null
  
)

export default component.exports